import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import type { FC, PropsWithChildren } from 'react'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import LovedBy10MillionDevelopersImage from './LovedBy10MillionDevelopersImage'

const copy = {
  heading: `Loved by 10 Million Developers`,
  description: `Twilio is optimized for builders, delivering a world-class experience and tools to let you build unique experiences, faster.`,
}

const link = {
  url: `https://www.twilio.com/solutions/`,
  text: `Explore our solutions`,
}

const LovedBy10MillionDevelopers: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <StyledSectionBase variant="centered">
        <Section.Copy>
          <StyledCopyTextBase centered={true}>
            <CopyText.Heading variant="h2" tag="h2">
              {copy.heading}
              <BlinkingLine>_</BlinkingLine>
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pLarge">
              {copy.description}
            </CopyText.Description>
            <CopyText.Link href={link.url}>{link.text}</CopyText.Link>
          </StyledCopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <LovedBy10MillionDevelopersImage />
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 64px;
    padding-bottom: 120px;
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 120px;
    }
  }
`

const cursor = keyframes`
  0% {
    opacity: 1;
  }
  25% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`

const BlinkingLine = styled.span`
  color: ${({ theme }) => theme.palette.twilio.gray[100]};
  animation: ${cursor} 1.5s infinite;
`

const StyledCopyTextBase = styled(CopyTextBase)`
  max-width: 844px;
  margin: 0 auto;
`

export default LovedBy10MillionDevelopers
